module.exports = __webpack_public_path__ + "fonts/DINPro-Light.001e05af.otf";